<div class="title" l10nTranslate>
  shared.issueStatus
  <div *ngIf="isInGroup" class="small-text" l10nTranslate>
    <span class="red">*</span>
    shared.thisIssueBelongsGroup
  </div>
</div>
<div class="status-row flex-grid" [ngClass]="{ disablePointer: isProfile }">
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 1)" [checked]="newChecked" l10nTranslate>shared.new</mat-checkbox>
  </div>
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 2)" [checked]="requirementDiscoveryChecked" l10nTranslate
      >shared.requirements<br /><span l10nTranslate>shared.discovery</span></mat-checkbox
    >
  </div>
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 3)" [checked]="businessReviewChecked" l10nTranslate
      >shared.business<br />
      <span l10nTranslate>shared.review</span>
    </mat-checkbox>
  </div>
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 4)" [checked]="prioritizedChecked" l10nTranslate
      >shared.prioritized</mat-checkbox
    >
  </div>
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 5)" [checked]="actionStatusChecked">
      <mat-form-field appearance="outline" class="tds__status-select">
        <mat-select hideSingleSelectionIndicator="true" [formControl]="selectedActionStatusCtrl" disableOptionCentering>
          <mat-option *ngFor="let status of actionStatuses" [value]="status.key">
            {{ status.value | uppercase }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-checkbox>
  </div>
  <div class="col">
    <mat-checkbox (click)="statusChange($event, 8)" [checked]="deployedToProdChecked" l10nTranslate
      >shared.deployedToProduction</mat-checkbox
    >
  </div>
</div>
